var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 15561",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0.124,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd081"
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 18151",
    style: {
      fill: "none",
      opacity: 0.1
    },
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 11426",
    transform: "translate(5.248 5.24)",
    style: {
      fill: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.785 17.496a.357.357 0 0 1-.21-.068.335.335 0 0 1-.137-.333l.852-4.738.048-.264-.194-.186-3.508-3.364a.334.334 0 0 1-.086-.331.352.352 0 0 1 .283-.23l4.86-.698.26-.038.117-.235 2.14-4.318a.356.356 0 0 1 .637-.002l2.167 4.314.118.233.258.037 4.858.699a.353.353 0 0 1 .286.23.334.334 0 0 1-.086.331l-3.509 3.364-.193.185.047.264.852 4.739.001.003v.003a.338.338 0 0 1-.355.4l-.012-.001h-.013a.364.364 0 0 1-.164-.039l-4.343-2.245-.23-.12-.23.12-4.347 2.247a.363.363 0 0 1-.167.04z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.102 16.89-.896-4.981 3.638-3.488-5.042-.725-2.272-4.523-2.245 4.53-5.046.726 3.639 3.488-.892 4.958 4.543-2.349 4.573 2.364m-9.317 1.106a.86.86 0 0 1-.503-.162.837.837 0 0 1-.336-.827l.852-4.739-3.511-3.367a.834.834 0 0 1-.213-.841.85.85 0 0 1 .69-.573l4.858-.698 2.14-4.318a.853.853 0 0 1 .767-.475c.327 0 .625.184.767.475l2.165 4.31 4.859.698a.85.85 0 0 1 .69.572.834.834 0 0 1-.213.842l-3.512 3.367.853 4.739a.837.837 0 0 1-.87.993.863.863 0 0 1-.392-.093l-4.347-2.247-4.347 2.247a.86.86 0 0 1-.397.097z",
    style: {
      fill: "#f49e0c",
      stroke: "none"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarChecked);
export default __webpack_public_path__ + "static/media/StarChecked.7e70d39f.svg";
export { ForwardRef as ReactComponent };